import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, BodyText, Box, MaterialSymbol, withStyles } from 'vopay';
import { Title, Button } from 'UI';
import styles from './BlockingDialog.module.scss';
import blockSubAccountIcon from './icons/blockSubAccount.svg';

const cn = withStyles(styles);

export type BlockAccountDialogProps = {
  accountName: string;
  onConfirm: (val: true) => void;
  onCancel: () => void;
};

const BlockAccountDialog: FunctionComponent<BlockAccountDialogProps> = ({ accountName, onConfirm, onCancel }) => {
  const { t } = useTranslation('translations', { keyPrefix: 'SubAccounts.BlockAccountDialog' });

  return (
    <Card className={cn('dialogueCard')}>
      <div className={cn('icon')}>
        <img src={blockSubAccountIcon} alt="Block Sub-Account" width="80" height="80" />
      </div>

      <div className={cn('title')}>
        <Title level="3">{t('title', { defaultValue: 'Block Sub-Account' })}</Title>
      </div>

      <BodyText className={cn('bodyText')}>
        <div className={cn('description')}>{t('description', { defaultValue: 'Blocking a sub-account will:' })}</div>
        <ul className={cn('bulletList')}>
          <li>{t('stopOutbound', { defaultValue: 'Stop all outbound transactions from the sub-account.' })}</li>
          <li>{t('redirectInbound', { defaultValue: 'Redirect all inbound transactions to the parent account.' })}</li>
        </ul>
      </BodyText>

      <BodyText className={cn('bodyText', 'description')}>
        {t('unblockMessage', { defaultValue: 'You can unblock anytime to restore normal behaviour.' })}
      </BodyText>

      <Box className={cn('infoBox')}>
        <MaterialSymbol icon="lan" fillAmount={1} size="20px" color="#2F82FFBF" className={cn('infoIcon')} />
        <BodyText className={cn('bodyText')} size="rg">
          {t('impactMessage', { accountName, defaultValue: 'This will impact {{accountName}} only.' })}
        </BodyText>
      </Box>

      <div className={cn('buttonContainer')}>
        <Button onClick={onCancel}>{t('cancelButton', { defaultValue: 'Cancel' })}</Button>
        <Button colorScheme="primary" onClick={() => onConfirm(true)}>
          {t('confirmButton', { defaultValue: 'Confirm & Block' })}
        </Button>
      </div>
    </Card>
  );
};

export default BlockAccountDialog;
